/* eslint-disable */
import React from 'react'
import styled from 'styled-components'
import LoadingShade from '../common/LoadingShade'
import { isMobile, refresh } from '../../utils/bomUtils'
import zIndex from '../../utils/zIndexScale'

const Wrap = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: ${zIndex.routeLoading};
`

const MobileWrap = styled(Wrap)`
  bottom: 0;
`

const Progress = styled.div`
  width: 100%;
  height: 2px;
  background: #f0b90b;
  animation: big 0.8s linear;
  @keyframes big {
    0% {
      width: 0%;
    }
    10% {
      width: 80%;
    }
    30% {
      width: 98%;
    }
    100% {
      width: 100%;
    }
  }
`

export default ({ error, retry, timedOut }) => {
  if (error) {
    if (window.__DEV__) {
      alert(error)
    }
    console.log(error)
    setTimeout(() => {
      refresh()
    }, 1000)
    return (
      <div>
        Sorry, there was a problem loading the page.<button onClick={retry}>Retry</button>
      </div>
    )
  } else if (timedOut) {
    return (
      <div>
        Taking a long time... <button onClick={retry}>Retry</button>
      </div>
    )
  }
  return (
    <>
      {!isMobile() ? (
        <Wrap>
          <Progress />
        </Wrap>
      ) : (
        <MobileWrap>
          <LoadingShade />
        </MobileWrap>
      )}
    </>
  )
}
